import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import SnackBar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

import EditIcon from "@material-ui/icons/Edit";
import InfoIcon from "@material-ui/icons/Info";
import DeleteIcon from "@material-ui/icons/Delete";

import { useStyles } from "../../../../../Components/CSS/FormStyle.css";
import CustomDialogBox from "../../../../../Components/CustomDialogBox/CustomDialogBox";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Axios from "axios";
import { url } from "../../../../../Config/Config";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";

class ExamConfigBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false,
      notificationOpen: false,
      examConfigId: "",
    };
  }

  handleDialogOpen = (examConfigId) => {
    this.setState({
      dialogOpen: true,
      examConfigId,
    });
  };

  handleDialogClose = () => {
    this.setState({
      dialogOpen: false,
    });
  };

  handleNotificationOpen = () => {
    this.setState({
      notificationOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
    });
  };

  showNotification = () => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.notificationOpen}
        onClose={this.handleNotificationClose}
        autoHideDuration={1600}
        style={{ top: 80, right: 10 }}
      >
        <MuiAlert
          onClose={this.handleNotificationClose}
          severity="error"
          elevation={6}
          variant="filled"
        >
          Deleted Successfully
        </MuiAlert>
      </SnackBar>
    );
  };

  handleDeleteExamConfig = async () => {
    try {
      const response = await Axios.delete(
        `${url}/api/exams/${this.state.examConfigId}`,
        {
          headers: {
            Authorization: `Bearer ${this.props.adminToken}`,
          },
        }
      );
      if (response.data.message === "Exam deleted successfully") {
        this.handleDialogClose();
        this.handleNotificationOpen();
        this.props.getExamConfig();
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleDeleteExamConfig();
      }
    }
  };

  render() {
    const { classes, data, index } = this.props;
    return (
      <TableRow key={index}>
        <TableCell align="center">{index + 1}</TableCell>
        <TableCell align="center">{data.session}</TableCell>
        <TableCell align="center">{data.examType}</TableCell>
        <TableCell align="center">{data.className}</TableCell>
        <TableCell align="center">
          {data.faculty ? data.faculty : "N/A"}
        </TableCell>
        <TableCell align="center">{data.group ? data.group : "N/A"}</TableCell>
        <TableCell align="center">{data.section}</TableCell>
        <TableCell align="center">{data.startDate}</TableCell>
        <TableCell align="center">{data.endDate}</TableCell>

        <TableCell align="center">
          <Tooltip
            title="Info"
            arrow
            className={classes.tooltip}
            onClick={() =>
              this.props.history.push(
                `/administration/examconfig/detail/${data._id}`
              )
            }
          >
            <InfoIcon />
          </Tooltip>
          <Tooltip
            title="Edit"
            arrow
            className={classes.tooltip}
            onClick={() =>
              this.props.history.push(
                `/administration/examconfig/edit/${data._id}`
              )
            }
          >
            <EditIcon />
          </Tooltip>
          <Tooltip
            title="Delete"
            arrow
            className={classes.tooltip}
            onClick={() => this.handleDialogOpen(data._id)}
          >
            <DeleteIcon />
          </Tooltip>
          {this.showNotification()}
        </TableCell>
        <CustomDialogBox
          open={this.state.dialogOpen}
          handleClose={this.handleDialogClose}
          handleDelete={this.handleDeleteExamConfig}
        />
      </TableRow>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(ExamConfigBody)));
